import Container from '@/components/Container';

const EmotionWheelSkeleton = () => {
  return (
    <div className={`w-full animate-pulse px-6`}>
      <Container>
        <div className="col-span-4 flex flex-col items-center justify-center gap-4 lg:col-span-6 lg:mr-10">
          <div className="h-[1rem] w-full animate-pulse bg-gray-300 "></div>
          <div className="h-[1rem] w-11/12 animate-pulse bg-gray-300 "></div>
          <div className="h-[1rem] w-full animate-pulse bg-gray-300 "></div>
          <div className="h-[1rem] w-11/12 animate-pulse bg-gray-300 "></div>
          <div className="h-[1rem] w-full animate-pulse bg-gray-300 "></div>
          <div className="h-[1rem] w-11/12 animate-pulse bg-gray-300 "></div>
          <div className="h-[2rem] w-1/2 animate-pulse bg-gray-300  py-6"></div>
        </div>

        <div className="col-span-4 flex gap-4 lg:col-span-6">
          <div className="h-[17rem] w-full animate-pulse rounded-full bg-gray-300  py-1 lg:h-[24rem]"></div>
        </div>
      </Container>
    </div>
  );
};

export default EmotionWheelSkeleton;
